export interface ShouldNotProceedResult {
    shouldNotProceed: boolean;
    warnings: string[];
}
